"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _UUID = _interopRequireDefault(require("./UUID"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var paranthesisRegex = /\{([^}]+)\}/;

var getEnumAndEnumNames = function getEnumAndEnumNames() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var texts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var output = '';

  for (var i = 0; i < values.length; i++) {
    if (output) output += ':::';
    output += "".concat(values[i]);

    if (texts[i]) {
      output += "{".concat(texts[i], "}");
    }
  }

  return output;
};

var getElementAndType = function getElementAndType(type) {
  switch (type) {
    case 'Number':
      return {
        type: 'number',
        element: 'NumberInput'
      };

    case 'Percentage':
      return {
        type: 'number',
        element: 'NumberInput',
        jsonSchemaOptions: {
          labelAfter: '%'
        }
      };

    case 'Text':
      return {
        type: 'string',
        element: 'TextInput'
      };

    case 'Options':
      return {
        type: 'string',
        element: 'Dropdown' // Could be RadioButtons, doesn't matter Bitsy form builder is only checking if enum and enum names

      };

    case 'Date':
      return {
        type: 'string',
        element: 'DatePicker',
        format: 'date'
      };

    default:
      throw new Error('Unsupported type');
  }
};

var getTypeByElement = function getTypeByElement(element, jsonSchemaOptions) {
  if (element === 'RadioButtons' || element === 'Dropdown') {
    return 'Options';
  }

  if (element === 'NumberInput') {
    if ((jsonSchemaOptions === null || jsonSchemaOptions === void 0 ? void 0 : jsonSchemaOptions.labelAfter) === '%') {
      return 'Percentage';
    }

    return 'Number';
  }

  if (element === 'DatePicker') {
    return 'Date';
  }

  return 'Text';
};

var getOptionsFromProperties = function getOptionsFromProperties() {
  var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var options = [];
  var props = properties;

  if (!Object.keys(properties).length) {
    props = {
      subfield1: {
        title: 'Sub Field 1',
        type: 'string',
        "enum": [],
        enumNames: []
      }
    };
  }

  var orders = Object.keys(props); // eslint-disable-next-line

  for (var _i = 0, _orders = orders; _i < _orders.length; _i++) {
    var order = _orders[_i];
    var _props$order = props[order],
        title = _props$order.title,
        element = _props$order.element,
        values = _props$order["enum"],
        texts = _props$order.enumNames,
        jsonSchemaOptions = _props$order.jsonSchemaOptions,
        minimum = _props$order.minimum,
        maximum = _props$order.maximum;
    options.push({
      attribute: title === order ? title : "".concat(order, "{").concat(title, "}"),
      type: getTypeByElement(element, jsonSchemaOptions),
      required: required.includes(order),
      values: getEnumAndEnumNames(values, texts),
      key: _UUID["default"].uuid(),
      minimum: minimum,
      maximum: maximum
    });
  }

  return options;
};

var NestedRepeaterItem = /*#__PURE__*/function (_React$Component) {
  _inherits(NestedRepeaterItem, _React$Component);

  var _super = _createSuper(NestedRepeaterItem);

  function NestedRepeaterItem(props) {
    var _this;

    _classCallCheck(this, NestedRepeaterItem);

    _this = _super.call(this, props);
    _this.state = {
      nodeName: _this.props.nodeName,
      options: getOptionsFromProperties(_this.props.properties, _this.props.required)
    };
    return _this;
  }

  _createClass(NestedRepeaterItem, [{
    key: "edit",
    value: function edit(attribute, index, e) {
      var clonedArray = _toConsumableArray(this.state.options);

      clonedArray[index][attribute] = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
      this.setState({
        options: clonedArray
      });
    }
  }, {
    key: "onModalClose",
    value: function onModalClose() {
      var _this2 = this;

      var options = this.state.options;
      var validOptions = options.filter(function (item) {
        return item.attribute && item.type;
      });
      var properties = validOptions.reduce(function (acc, curr) {
        var _this2$props$properti;

        var title = paranthesisRegex.exec(curr.attribute);
        var prop = curr.attribute.split('{')[0];
        var possibleValues;
        var possibleTexts;

        if (curr.type === 'Options') {
          possibleValues = curr.values.split(':::').map(function (v) {
            return v.split('{')[0];
          });
          possibleTexts = curr.values.split(':::').map(function (v) {
            var val = paranthesisRegex.exec(v);
            if (val) return val[1];
            return v.split('{')[0];
          });
        }

        var minimum;
        var maximum;

        if (curr.type === 'Number') {
          minimum = curr.minimum ? parseInt(curr.minimum, 10) : undefined;
          maximum = curr.maximum ? parseInt(curr.maximum, 10) : undefined;
        }

        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, prop, _objectSpread(_objectSpread(_objectSpread({}, (_this2$props$properti = _this2.props.properties) === null || _this2$props$properti === void 0 ? void 0 : _this2$props$properti[prop]), {}, {
          element: undefined,
          jsonSchemaOptions: undefined
        }, getElementAndType(curr.type)), {}, {
          title: title ? title[1] : prop,
          "enum": possibleValues,
          enumNames: possibleTexts,
          description: '',
          minimum: minimum,
          maximum: maximum
        })));
      }, {});
      var required = validOptions.filter(function (item) {
        return item.required;
      }).map(function (item) {
        return item.attribute.split('{')[0];
      });
      this.props.onClose({
        required: required,
        properties: properties,
        nodeName: this.props.nodeName
      });
    }
  }, {
    key: "addOption",
    value: function addOption(index) {
      var oldOptions = _toConsumableArray(this.state.options);

      oldOptions.splice(index + 1, 0, {
        attribute: '',
        type: '',
        values: '',
        required: false,
        key: _UUID["default"].uuid()
      });
      this.setState({
        options: oldOptions
      });
    }
  }, {
    key: "removeOption",
    value: function removeOption(index) {
      var oldOptions = _toConsumableArray(this.state.options);

      oldOptions.splice(index, 1);
      this.setState({
        options: oldOptions
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal show d-block",
        role: "dialog"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "dynamic-option-list"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-3"
      }, /*#__PURE__*/_react["default"].createElement("b", null, "Sub fields")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-3"
      }, /*#__PURE__*/_react["default"].createElement("b", null, "Type")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-3"
      }, /*#__PURE__*/_react["default"].createElement("b", null, "Values")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-1"
      }, /*#__PURE__*/_react["default"].createElement("b", null, "Required")))), this.state.options.map(function (option, index) {
        var this_key = "edit_".concat(option.key);
        return /*#__PURE__*/_react["default"].createElement("li", {
          className: "clearfix",
          key: this_key
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "row"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-sm-3"
        }, /*#__PURE__*/_react["default"].createElement("input", {
          style: {
            width: '100%'
          },
          className: "form-control",
          type: "text",
          value: option.attribute,
          onChange: _this3.edit.bind(_this3, 'attribute', index)
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-sm-3"
        }, /*#__PURE__*/_react["default"].createElement("select", {
          className: "form-control",
          style: {
            width: '100%'
          },
          type: "text",
          value: option.type,
          onChange: _this3.edit.bind(_this3, 'type', index)
        }, /*#__PURE__*/_react["default"].createElement("option", {
          value: ""
        }, "Select one"), /*#__PURE__*/_react["default"].createElement("option", {
          value: "Text"
        }, "Text"), /*#__PURE__*/_react["default"].createElement("option", {
          value: "Date"
        }, "Date"), /*#__PURE__*/_react["default"].createElement("option", {
          value: "Number"
        }, "Number"), /*#__PURE__*/_react["default"].createElement("option", {
          value: "Options"
        }, "Options"), /*#__PURE__*/_react["default"].createElement("option", {
          value: "Percentage"
        }, "Percentage"))), /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-sm-3"
        }, option.type === 'Number' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
          style: {
            width: '50%',
            marginRight: 0
          },
          className: "form-control",
          type: "number",
          placeholder: "min",
          value: option.minimum,
          onChange: _this3.edit.bind(_this3, 'minimum', index)
        }), /*#__PURE__*/_react["default"].createElement("input", {
          style: {
            width: '50%',
            marginRight: 0
          },
          className: "form-control",
          type: "number",
          placeholder: "max",
          value: option.maximum,
          onChange: _this3.edit.bind(_this3, 'maximum', index)
        })) : /*#__PURE__*/_react["default"].createElement("input", {
          style: {
            width: '100%'
          },
          className: "form-control",
          type: "text",
          value: option.values,
          disabled: option.type !== 'Options',
          placeholder: option.type === 'Options' ? 'One{1}:::Two{2}' : '',
          onChange: _this3.edit.bind(_this3, 'values', index)
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-sm-1"
        }, /*#__PURE__*/_react["default"].createElement("input", {
          className: "form-control",
          type: "checkbox",
          onChange: _this3.edit.bind(_this3, 'required', index),
          checked: option.required
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-sm-2"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "dynamic-options-actions-buttons"
        }, /*#__PURE__*/_react["default"].createElement("button", {
          onClick: _this3.addOption.bind(_this3, index),
          className: "btn btn-success"
        }, /*#__PURE__*/_react["default"].createElement("i", {
          className: "fas fa-plus-circle"
        })), index > 0 && /*#__PURE__*/_react["default"].createElement("button", {
          onClick: _this3.removeOption.bind(_this3, index),
          className: "btn btn-danger"
        }, /*#__PURE__*/_react["default"].createElement("i", {
          className: "fas fa-minus-circle"
        }))))));
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-default",
        "data-dismiss": "modal",
        onClick: this.onModalClose.bind(this)
      }, "Close")))));
    }
  }]);

  return NestedRepeaterItem;
}(_react["default"].Component);

exports["default"] = NestedRepeaterItem;